import React from 'react';
import Util from './Util';

const Header = props => (
	<div className="branded-tracking-header">
		{Util.canUseBrandedEmails() ? (
			<>
				<h1>Brand Settings</h1>
				<a
					role="button"
					tabIndex="0"
					className="learning-center"
					onClick={Util.openLearningCenterArticle}
				>
					Learning Center
				</a>
				<p>
					Choose which logo, color theme, and links to display on your Branded Tracking
					Page and Branded Emails.
				</p>
			</>
		) : (
			<>
				<h1>Branded Tracking Page Setup</h1>
				<p>
					These settings will apply to your Tracking Page. Choose which logo, color theme,
					and links to display.
				</p>
			</>
		)}
	</div>
);

export default Header;
